import { Component } from '@angular/core';

@Component({
    selector: 'is-unauthorised',
    templateUrl: './unauthorised.component.html',
    styleUrls: ['./unauthorised.component.scss'],
    standalone: false
})
export class UnauthorisedComponent {}
